module.exports = __webpack_public_path__ + "img/user-portfolio-mobile@2x.a7c8502.png";